import urljoin from 'url-join';
import { EmbedConfig } from '../..';
import render from '../../designs/paper';

import GothamBookWoff2 from '../../../../../../client/assets/Gotham-Book.woff2';

import './styles/style.scss';

const additionalFonts = (config: EmbedConfig) => {
  const GothamBookWoff2Path = urljoin(config.goBaseUrl, GothamBookWoff2);

  return `
    @font-face {
      font-family: 'Gotham Book';
      font-style: normal;
      src: url('${GothamBookWoff2Path}') format('woff2');
    }`;
};

render(additionalFonts);
